import { render, staticRenderFns } from "./ComTable.vue?vue&type=template&id=c9639366&scoped=true"
import script from "./ComTable.vue?vue&type=script&lang=js"
export * from "./ComTable.vue?vue&type=script&lang=js"
import style0 from "./ComTable.vue?vue&type=style&index=0&id=c9639366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9639366",
  null
  
)

export default component.exports